import React from 'react';
import './styles.css';

// Import Components
import AdminDesign from '~/components/admin';

const Dashboard: React.FC<any> = ({ match }) => {
    return (
        <AdminDesign pageTitle="API Energizou" title="Dashboard" className="db">
        </AdminDesign>
    );
}

export default Dashboard;